<template>
    <form-repeater
        :repeats="repeats"
        :add="$t('forms.auth.referrals.microcopy.specialities_repeater.add')"
        :hint="$t('forms.auth.referrals.microcopy.specialities_repeater.hint')"
        :remove="$t('forms.auth.referrals.microcopy.specialities_repeater.remove')"
        :isDisabled="isDisabled"
        @add="addRepeat()"
        @remove="removeRepeat($event)"
    >
        <template #heading="{ index }">
            {{ $t('forms.auth.referrals.microcopy.specialities_repeater.heading', { index: index + 1 }) }}
        </template>

        <template #default="{ data, index }">
            <form-wrapper :isSubmittable="false">
                <form-row>
                    <form-cell>
                        <select-field
                            :label="$t('forms.auth.referrals.fields.speciality.label')"
                            :placeholder="$t('forms.auth.referrals.fields.speciality.placeholder')"
                            :hasAutofocus="true"
                            :isRequired="!isDisabled"
                            :isDisabled="isDisabled"
                            :options="specialities"
                            :formData="data"
                            :errorPath="valuePathField(index, 'specialityId')"
                            :valuePath="valuePathField(index, 'specialityId')"
                            :formRepeater="true"
                            @change="changeRepeat(index, $event)"
                        ></select-field>
                    </form-cell>
                </form-row>

                <form-row>
                    <form-cell>
                        <select-field
                            :label="$t('forms.auth.referrals.fields.subspeciality.label')"
                            :placeholder="$t('forms.auth.referrals.fields.subspeciality.placeholder')"
                            :isDisabled="hasNoSubSpecialities(data, index) || isDisabled"
                            :options="subSpecialities(data, index)"
                            :formData="data"
                            :errorPath="valuePathField(index, 'subSpecialityId')"
                            :valuePath="valuePathField(index, 'subSpecialityId')"
                            :formRepeater="true"
                            @change="changeRepeat(index, $event)"
                        ></select-field>
                    </form-cell>
                </form-row>

                <form-row>
                    <form-cell>
                        <year-field
                            :label="$t('forms.auth.referrals.fields.practicing_since.label')"
                            :placeholder="$t('forms.auth.referrals.fields.practicing_since.placeholder')"
                            :isRequired="!isDisabled"
                            :isDisabled="isDisabled"
                            :formData="data"
                            :errorPath="valuePathField(index, 'practicingSince')"
                            :valuePath="valuePathField(index, 'practicingSince')"
                            :formRepeater="true"
                            @change="changeRepeat(index, $event)"
                        ></year-field>
                    </form-cell>
                </form-row>
            </form-wrapper>
        </template>
    </form-repeater>
</template>

<script>
    import FormFragmentMixin from 'mixins/FormFragmentMixin'
    import FormRepeaterMixin from 'mixins/FormRepeaterMixin'
    import FormSpecialitiesMixin from 'mixins/FormSpecialitiesMixin'

    export default {
        mixins: [FormFragmentMixin, FormRepeaterMixin, FormSpecialitiesMixin],
    }
</script>
